import React, { useState, useEffect } from "react";
import CardCategories from "./CardCategories";
import { Grid, Typography, Link, Stack, Container } from "@mui/material";
import axios from "axios";
import config from "../config";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function HomeCategories() {
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    axios
      .get(`${config.url}/product_categories?offset=0&limit=9999`, config.token)
      .then((res) => {
        setCategoryList(res.data.data);
      })
      .catch((e) => console.log(e.response.data.data));
    // eslint-disable-next-line
  }, []);

  return (
    <Container maxWidth="xl" sx={{ marginTop: "30px" }}>
      <Grid item xs={12} container>
        {categoryList?.map(
          (data, index) =>
            data.products.length > 0 && (
              <Grid container key={index}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  lg={12}
                  container
                  sx={{ pt: "20px" }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      textAlign: "left",
                      color: "#5a5a56",
                    }}
                  >
                    {data?.name}
                  </Typography>
                  <Typography flexGrow={1} />
                  <Link
                    href={`/category/${data?.id}`}
                    underline="none"
                    sx={{ color: "#FF0000", fontSize: "30px" }}
                  >
                    <Stack direction="row">
                      <Typography
                        sx={{ textAlign: "center" }}
                        // variant='h6'
                      >
                        More
                      </Typography>
                      <KeyboardArrowRightIcon />
                    </Stack>
                  </Link>
                </Grid>

                <Grid container spacing={2} sx={{ mt: "10px" }}>
                  {data?.products?.map((isValue, idx) => (
                    <Grid item xs={4} sm={3} lg={2} key={idx}>
                      {idx < 6 ? <CardCategories data={isValue} /> : ""}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )
        )}
      </Grid>
    </Container>
  );
}
